import { useEffect, useState } from "react";
import { addSavedCar, isSavedCar, removeSavedCar } from "../../car-filter/utils/localStorage";
import { useUscSelector } from "../redux/store";

/**
 * Use this hook to know and update the saved state of the current vehicle
 * The state is synced with the localstorage
 */
const useSaveButton = (): {
    isSaved: boolean;
    saveClick: () => void;
} => {
    const vehicle = useUscSelector((state) => state.vehicle);
    const commonSettings = useUscSelector((state) => state.commonSettings);

    const [isSaved, setIsSaved] = useState(false);

    const { country, language } = commonSettings;
    const params = { context: vehicle.type, country, language };

    const saveClick = (): void => {
        if (isSaved) removeSavedCar(params, vehicle.vehicleForSaleId);
        else {
            addSavedCar(params, vehicle.vehicleForSaleId);
        }
        setIsSaved(!isSaved);
    };

    // Read saved cars from carFilter localStorage.
    useEffect(() => {
        setIsSaved(isSavedCar(params, vehicle.vehicleForSaleId));
    }, []);

    return { isSaved, saveClick };
};
export default useSaveButton;
